import { useEffect, useState } from 'react'

/**
 * Live media-query hook backed by matchMedia. Unlike a one-time
 * `window.innerWidth` check in a useState initializer, this actually reacts
 * to the viewport changing after mount (resize, un-maximize, orientation
 * change, DevTools opening) — see ModernOSINTDashboard.tsx's sidebar state,
 * which used to freeze open/collapsed at whatever the width was on first
 * render and never recover.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false
  )

  useEffect(() => {
    if (typeof window === 'undefined') return
    const mql = window.matchMedia(query)
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches)
    setMatches(mql.matches)
    mql.addEventListener('change', handler)
    return () => mql.removeEventListener('change', handler)
  }, [query])

  return matches
}
